<section class="vh-100">
  <div class="container-fluid h-custom">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-md-9 col-lg-6 col-xl-5">
        <img src="assets/images/r10x_logo_login.png" class="img-fluid">
      </div>
      <div class="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
        <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
          <div class="d-flex flex-row align-items-center justify-content-center justify-content-lg-start my-4">
            <p class="lead fw-bold mb-0 me-3">CPG Login</p>
          </div>

          <!-- Username input -->
          <div class="form-outline mb-4">
            <label class="form-label" for="username">Username</label>
            <input type="text" formControlName="username" id="username" class="form-control"
              placeholder="Enter username" />
          </div>

          <!-- Password input -->
          <div class="form-outline mb-3">
            <label class="form-label" for="password">Password</label>
            <input type="password" formControlName="password" id="password" class="form-control"
              placeholder="Enter password" />
          </div>

          <!--
          <div class="d-flex justify-content-between align-items-center">
            <div class="form-check mb-0">
              <input class="form-check-input me-2" type="checkbox" value="" id="form2Example3" />
              <label class="form-check-label" for="form2Example3">
                Remember me
              </label>
            </div>
            <a href="#!" class="text-body">Forgot password?</a>
          </div>-->

          <div class="text-center text-lg-start mt-4 pt-2">
            <button type="submit" class="btn btn-secondary text-white fw-bold mb-4" style="padding-left: 2.5rem; padding-right: 2.5rem;" [disabled]="buttonLoader">
              Login
              <div class="spinner-border spinner-border-sm" role="status" *ngIf="buttonLoader"></div>
            </button>

            <!--<p class="small mt-2 pt-1 mb-0">Don't have an account? <a class="cursor-pointer link-danger fw-bold" (click)="cpgRegistration(cpgRegisterModal)">Register</a></p>-->
          </div>

        </form>
        <br><br><br><br>
      </div>
    </div>
  </div>

  <div class="fixed-bottom d-flex flex-column flex-md-row text-center text-md-start justify-content-between py-2 px-2 px-xl-5 bg-primary">
    <!-- Copyright -->
    <div class="text-white mb-3 mb-md-0">
      © 2025 R10X Inc. All Rights Reserved
    </div>
  </div>
</section>

<ng-template #cpgRegisterModal let-modal>
  <div class="modal-body" style="padding: 0;">
    <app-cpg-registration (registrationResponse)="onRegistrationResponse($event)"></app-cpg-registration>
  </div>
</ng-template>
